import styled from 'styled-components';
import Box from '@mui/material/Box';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import colors from '../../../../../styles/colors';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const TabPanel = styled(Box).attrs(({ value, index }) => ({
  role: 'tabpanel',
  hidden: value !== index,
}))`
  flex: 1;
  overflow-y: auto;
  padding: 16px 4px;
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 20px 24px;
  border: 1px solid ${colors.shades.gamma1};
  border-radius: 10px;
  background: ${colors.shades.secondary10};
`;

export const Body = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 48px minmax(0, 1fr) 72px;
  align-items: start;
  column-gap: 12px;
`;

export const ExerciseBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  min-width: 0;
`;

export const Chip = styled.span`
  display: inline-block;
  max-width: 100%;
  background: ${colors.shades.gamma12};
  color: ${colors.shades.gamma10};
  border-radius: 12px;
  padding: 3px 10px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.6px;
  text-transform: uppercase;
`;

export const ExerciseName = styled.div`
  font-size: 15px;
  font-weight: 700;
  color: ${colors.base.beta};
  word-break: break-word;
`;

export const Chevron = styled(ChevronRightIcon)`
  justify-self: center;
  align-self: center;
  color: ${colors.shades.gamma9};
`;

export const MetaItem = styled.div`
  font-size: 13px;
  color: ${colors.shades.gamma11};
`;

export const ReasonQuote = styled.div`
  font-style: italic;
  font-size: 13px;
  color: ${colors.shades.gamma11};
  word-break: break-word;
`;

export const ActionSlot = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  align-self: flex-start;
`;

export const EmptyState = styled.div`
  padding: 32px;
  text-align: center;
  color: ${colors.shades.gamma11};
`;
